import DonutChart from "@components/UI/DonutChart";
import { useAppSelector } from "@store/hooks";
import { selectCurrentCategory, selectOverviewItems } from "@store/mainReducer";
import React, { useState } from "react";
import ItemsCapacity from "./ItemsCapacity";
import styled from "styled-components";
import { CATEGORY_LABELS_ } from "@utils/constants";
import Infos from "@assets/images/infos.svg";
import Modal from "@components/UI/Modal";
import { useViewportMode } from "@utils/useMobileDetection";

const StyledDiv = styled.div`
  .total {
    font-size: 19px;
    font-weight: bold;
    line-height: 28px;
    text-align: center;
  }
  @media (max-width: 768px) and (min-width: 501px) {
    .total {
      font-size: 13px;
      line-height: 16px;
    }
  }
  @media (max-width: 500px) {
    .total {
      font-size: 15px;
      line-height: 20px;
    }
  }
`;

const Capacities = () => {
  const { totaux, camembert } = useAppSelector(selectOverviewItems);
  const currentCategory = useAppSelector(selectCurrentCategory);
  const totalItem = totaux.find((item) => item.category === currentCategory);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isTablet } = useViewportMode();

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const containerClass = isTablet
    ? "flex h-auto py-[12px] px-[10px] bg-white gap-[12px] flex-col justify-start rounded-[4px]"
    : "flex max-sm:h-auto sm:h-[431px] sm:py-[5px] py-[20px] px-[20px] bg-white sm:gap-[24px] gap-[15px] flex-col sm:justify-center justify-start rounded-[4px] sm:rounded-[8px]";

  return (
    <StyledDiv className={containerClass}>
      <div className="total flex justify-center gap-[5px] items-center">
        <div className="flex-1">{`Puissance totale allouee${currentCategory !== "TOTAL" ? " - " + CATEGORY_LABELS_[currentCategory] : ""}`}</div>
        <div className="flex-shrink-0">
          <img
            className="w-6 h-6"
            src={Infos}
            alt="Infos"
            onClick={handleOpenModal}
            style={{ cursor: "pointer" }}
          />
        </div>
        <Modal isOpen={isModalOpen} onClose={handleCloseModal} />
      </div>
      <div className="col-12">
        <DonutChart
          data={camembert}
          total={totalItem.total}
          currentCategory={currentCategory}
          size="SIZE_6"
        />
      </div>
      <div className="col-12">
        <ItemsCapacity totaux={totaux} />
      </div>
    </StyledDiv>
  );
};

export default Capacities;
